import { TableCell, TableRow } from "@mui/material";
import React from "react";

interface BaseTableRowProps {
  currency: string;
  aggregationUnit: string;
  item: any;
  selectedId?: string | null;
  onRowClick?: (item: any) => void;
  children: React.ReactNode;
}

export const BaseTableRow = ({
  currency,
  aggregationUnit,
  item,
  selectedId,
  onRowClick,
  children
}: BaseTableRowProps) => {
  if (!item) {
    return null;
  }

  const handleRowClick = () => onRowClick && onRowClick(item);

  return (
    <TableRow
      key={item.code}
      onClick={handleRowClick}
      sx={{
        cursor: "pointer",
        "&:hover": { backgroundColor: "#f5f5f5" },
        ...selectedId === item.id && { backgroundColor: "#e8f5e9" },
        fontSize: 13
      }}
    >
      <TableCell
        sx={{
          fontSize: 13
        }}
      >
        {item.name}
      </TableCell>
      {aggregationUnit &&
        aggregationUnit !== "numberOfLocations" &&
        aggregationUnit !== "numberOfRisks" &&
        <TableCell
          sx={{
            fontSize: 13
          }}
        >
          {currency}
        </TableCell>}
      {aggregationUnit &&
        aggregationUnit !== "numberOfLocations" &&
        <TableCell
          sx={{
            fontSize: 13
          }}
        >
          {item[aggregationUnit]}
        </TableCell>}
      {children}
    </TableRow>
  );
};
